import { render, staticRenderFns } from "./SpinnerColor2.vue?vue&type=template&id=00c8a946&scoped=true"
import script from "./SpinnerColor2.vue?vue&type=script&lang=js"
export * from "./SpinnerColor2.vue?vue&type=script&lang=js"
import style0 from "./SpinnerColor2.vue?vue&type=style&index=0&id=00c8a946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8a946",
  null
  
)

export default component.exports